class OptionSource {
  static fromJSON(json) {
    switch (json.type) {
      case "field":
        return new FieldSource(json);
      case "static":
        return new StaticSource(json);
      default:
        throw new Error(`Invalid type: ${json.type}`);
    }
  }
}
export const DEFAULT_LIMIT = 20;
export class FieldSource extends OptionSource {
  constructor({ field, limit }) {
    super();
    this.TYPE = "field";
    this._field = field;
    this._limit = limit != null ? limit : DEFAULT_LIMIT;
  }
  static create(field, limit = DEFAULT_LIMIT) {
    return new FieldSource({ type: "field", field, limit });
  }
  static createDefault() {
    return new FieldSource({ type: "field", field: void 0, limit: DEFAULT_LIMIT });
  }
  get type() {
    return this.TYPE;
  }
  get field() {
    return this._field;
  }
  get limit() {
    return this._limit;
  }
  toJSON() {
    return {
      type: this.TYPE,
      field: this._field,
      limit: this._limit
    };
  }
}
export class StaticSource extends OptionSource {
  constructor({ values }) {
    super();
    this.TYPE = "static";
    this._values = values;
  }
  static createDefault() {
    return StaticSource.create([]);
  }
  static create(values) {
    return new StaticSource({ type: "static", values });
  }
  get type() {
    return this.TYPE;
  }
  get values() {
    return this._values;
  }
  toJSON() {
    return {
      type: "static",
      values: this._values
    };
  }
}
export default OptionSource;
